import React, { useState } from 'react';
import { Button, Popover, PopoverBody } from 'reactstrap';

export type HelpPopoverProps = {
  text: React.ReactNode;
  id: string;
  size?: string;
  propagateClick?: boolean;
};

export default function HelpPopover({
  text,
  id,
  size = 'md',
  propagateClick = true,
}: HelpPopoverProps) {
  const [popoverOpen, setPopoverOpen] = useState(false);

  const toggle = (e: React.MouseEvent) => {
    if (!propagateClick) {
      e.stopPropagation();
    }
    setPopoverOpen(!popoverOpen);
  };

  const targetId =
    'popover-' +
    id
      .replace(/[^a-zA-Z0-9_-]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  return (
    <span className="ms-1">
      <Button
        size={size}
        color="secondary"
        type="button"
        id={targetId}
        onClick={(e) => toggle(e)}
      >
        ?
      </Button>
      <Popover
        placement="right"
        isOpen={popoverOpen}
        toggle={(e) => toggle(e)}
        target={targetId}
        popperClassName="bs-popover-auto"
      >
        {/*<PopoverHeader>Help</PopoverHeader>*/}
        <PopoverBody>{text}</PopoverBody>
      </Popover>
    </span>
  );
}
